import BreadCrumb from "../../../components/BreadCrumb";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import { Grid, useMediaQuery } from "@mui/material";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import { ItemOption, ItemStatus } from "../../../utils/DropDown";
import useStyles from "../styles";
import Modal from "../../../components/Modal";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import InputGroup from "../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../data/api";
import useValidator from "../../../hooks/useValidator";
import PageLoader from "../../../components/PageLoader";
import Badge from "../../../components/Badge";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const PAYMENT_HISTORY = "/api/v1/invoices/student-invoices/transactions";

const PaymentHistory = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchResult, setSearchResult] = useState([]);
  const [getLoading, setGetLoading] = useState(false);
  const [itemModal, setItemModal] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [invoiceItem, setInvoiceItem] = useState([]);
  const [invoiceValidator, showInvoiceValidator] = useValidator();
  const [discountModal, setDiscountModal] = useState(false);
  const [customDiscount, setCustomDiscount] = useState(false);
  const [itemform, setItemForm] = useState({
    status: "",
    fee_option: "",
    item: ""
  });

  const handleDiscountModal = () => {
    setDiscountModal(!discountModal);
  };

  const handleCustomDiscount = () => {
    setCustomDiscount(!customDiscount);
  };

  /**
 * Closes the edit modal and resets the edit form.
 * @function
 */

  /**
 * Opens the edit modal and populates it with the selected row's data.
 * @function
 * @param {Object} row - The row data to edit.
 */
  //   const handleEditInvoiceItem = (row) => {
  //     setEditItemModal(!edititemModal);
  //     setCurrentRow(row);
  //     setEditItemForm({
  //       ...edititemform,
  //       status: row?.status,
  //       fee_option: row?.fee_option,
  //       item: row?.item
  //     });
  //   };

  /**
 * Closes the delete confirmation modal.
 * @function
 */
  /**
 * Handles changes in the create item form inputs.
 * @function
 * @param {Object} e - The event object from the input element.
 */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemForm({ ...itemform, [name]: value });
  };

  /**
 * Handles changes in the edit item form inputs.
 * @function
 * @param {Object} e - The event object from the input element.
 */
  /**
 * Toggles the create item modal visibility.
 * @function
 */
  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
  };

  /**
 * Opens the delete confirmation modal for a specific item.
 * @function
 * @param {Object} row - The row data to potentially delete.
 */
  //   const handleDeleteModal = (row) => {
  //     setCurrentRow(row);
  //     setDeleteModal(!deleteModal);
  //   };
  /**
 * Fetches all invoice items from the server.
 * @function
 * @description Makes a GET request to SCH_ITEM endpoint and updates the invoice items state.
 */
  const getAllInvoiceItem = () => {
    setGetLoading(true);
    httprequest
      .get(PAYMENT_HISTORY)
      .then((res) => {
        setInvoiceItem(res?.data?.data);
        setSearchResult(res?.data?.data);
        setGetLoading(false);
      }).catch((err) => {
        setGetLoading(true);
        toast.error(err?.response?.data?.message);
      });
  };

  /**
 * Handles creation of a new invoice item.
 * @function
 * @description Validates the form, makes a POST request to SCH_ITEM endpoint,
 * and handles the response or error.
 */
  const handleCreateItem = () => {
    if (invoiceValidator.allValid()) {
      setItemLoading(true);
      httprequest
        .post(PAYMENT_HISTORY, itemform)
        .then((res) => {
          setItemLoading(false);
          toast.success(res?.data?.message || "Item created successfully");
          handleOpenItemMOdal();
          getAllInvoiceItem();
        })
        .catch((err) => {
          setItemLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showInvoiceValidator(true);
    }
  };

  /**
 * Handles editing of an existing invoice item.
 * @function
 * @description Validates the form, makes a PATCH request to update the item,
 * and handles the response or error.
 */
  //   const handleEditItem = () => {
  //     if (editinvoiceValidator.allValid()) {
  //       setItemLoading(true);
  //       httprequest
  //         .patch(`${SCH_ITEM}/${currentRow?.id}`, edititemform)
  //         .then((res) => {
  //           setItemLoading(false);
  //           toast.success(res?.data?.message || "Item created successfully");
  //           getAllInvoiceItem();
  //           handleCloseEditModal();
  //         })
  //         .catch((err) => {
  //           setItemLoading(false);
  //           toast.error(err?.response?.data);
  //         });
  //     } else {
  //       showEditInvoiceValidator(true);
  //     }
  //   };

  //   /**
  //  * Handles deletion of an invoice item.
  //  * @function
  //  * @description Makes a DELETE request to remove the item and handles the response or error.
  //  */
  //   const handleDeleteItem = () => {
  //     setIsItemDeleting(true);
  //     httprequest.delete(`${SCH_ITEM}/${currentRow?.id}`).then((res) => {
  //       setIsItemDeleting(false);
  //       toast.success(res?.data?.message);
  //       getAllInvoiceItem();
  //       handleCloseDeleteModal();
  //     }).catch((err) => {
  //       setIsItemDeleting(false);
  //       toast.error(err?.response?.data?.message);
  //     });
  //   };

  /**
 * Column definitions for the invoice items data table.
 * @type {Array<Object>}
 * @property {string} name - The column header name.
 * @property {Function} selector - Function to render cell content.
 * @property {boolean} [center] - Whether to center the column content.
 * @property {Function} [cell] - Alternative render function for cells.
 * @property {boolean} [sortable] - Whether the column is sortable.
 */
  const columns = [
    {
      name: "Invoice Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice Name</p>}
          {row?.invoice_name || "--/--"}
        </>
      )
    },
    {
      name: "Invoice Number",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Invoice Number</p>}
          {row?.invoice_no || "--/--"}
        </>
      )
    },
    {
      name: "Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount</p>}
          {row?.amount || "--/--"}
        </>
      )
    },
    {
      name: "Date Created",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Date Created</p>}
          {row?.created_at?.substring(0, 10)}
        </>
      )
    },
    {
      name: "Paid For",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount Paid</p>}
          {`${row?.student?.last_name} ${row?.student?.first_name}` || "--/--"}
        </>
      )
    },
    {
      name: "Method",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Method</p>}
          <div className="flex gap-8">
            {row?.payment_method?.toLowerCase() === "bank transfer" && (
              <Icon icon="mdi:bank-transfer" width="24" height="24" />
            )}
            {row?.payment_method?.toLowerCase() === "cash" && (
              <Icon icon="mdi:cash" width="24" height="24" />
            )}
            {row?.payment_method?.toLowerCase() === "cheque" && (
              <Icon icon="mdi:note" width="24" height="24" />
            )}
            {row?.payment_method?.toLowerCase() === "payment link" && (
              <Icon icon="mdi:link" width="24" height="24" />
            )}
            {row?.payment_method}
          </div>
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (
        <p style={{ display: "flex", flexDirection: "column", margin: 0, marginBlock: 0 }}>
          {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
          <Badge status={row?.status} />
        </p>
      )
    },
    {
      name: "",
      center: "true",
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          {/* <div className="flex gap-10">
            <div className="flex gap-10">
              <Button
                variant="primaryoutline"
                buttonSize="small"
                color="btnfontprimary"
                buttonName="View"
                onClick={() => navigate("/payment/payment-review")}
              />
              <Button
                // onClick={handleDiscountModal}
                variant="primary"
                buttonSize="small"
                color="btndefault"
                buttonName="Review"
              />
            </div>
          </div> */}
          <button
            className="table-action-icon"
            onClick={() => navigate(`/payment/payment-history/${row?.id}`)}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Handles search functionality for invoice items.
 * @function
 * @param {Object} e - The event object from the search input.
 * @description Filters invoice items based on search terms matching status, fee_option, item, or payment_method.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = invoiceItem?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                              data?.fee_option
                                ?.toLowerCase()
                                .includes(word.toLowerCase()) ||
                              data?.item
                                ?.toLowerCase()
                                .includes(word.toLowerCase()) ||
                                data?.payment_method
                                  ?.toLowerCase()
                                  .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getAllInvoiceItem();
  }, []);

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb link_one="/payment/overview" link_one_name="Payments" active="Payment History" description="See all payments history" />
          </div>
          {/* <div className="flex gap-10">
            <Button
              variant="primaryoutline"
              buttonSize="medium"
              color="btnfontprimary"
              buttonName="Custom Discount"
              onClick={handleCustomDiscount}
            />
            <Button
              onClick={handleDiscountModal}
              variant="primary"
              buttonSize="medium"
              color="btndefault"
              buttonName="Create Discount"
            />
          </div> */}
        </div>
        <div className="page-content margin-top-30">
          <>
            {getLoading ? (
              <PageLoader />
            ) : (
              <Table
                data={searchResult}
                columns={columns}
                subHeader={true}
                pagination
                subHeaderComponent={
                  <div className="action_div">
                    <TableSearch
                      placeholder="Search here..."
                      searchTableFunc={handleSearchStudent}
                    />
                  </div>}
              />
            )}
          </>
        </div>
        {/* Add Option */}
        <Modal
          title="Create Invoice Item"
          subtitle={
            <div>
                Create an item to be used in your invoices.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Item Name"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="item"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Item Option"
                    required
                    children={
                      <select name="fee_option" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {ItemOption?.map((itemoptions) => {
                          return (
                            <option key={itemoptions.key} value={itemoptions?.key}>
                              {itemoptions?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Status"
                    required
                    children={
                      <select name="status" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {ItemStatus?.map((status) => {
                          return (
                            <option key={status?.key} value={status?.key}>
                              {status?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Cancel"
                //   onClick={handlePostStudentResult}
                //   isLoading={resultCreating}
                />
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Save"
                  onClick={handleCreateItem}
                  isLoading={itemLoading}
                />
              </div>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
        {/* Add Option */}
        <Modal
          title="Create Discount"
          subtitle={
            <div>
                 Create discount for your student
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Name"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Validity Period"
                    margin="normal"
                    inputType="date"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Description"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Value"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.quelabel}>Reason <span className="input-required"> *</span></label>
                  <div className={classes.textandimg}>
                    <textarea
                      type="text"
                      placeholder="Input reason"
                      name="description"
                      onChange={handleChange}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonName="Apply"
                buttonSize="full"
                color="btndefault"
                // onClick={handleCreateNotice}
                // isLoading={isLoading}
              />
            </>
          }
          isopen={discountModal}
          closeModal={handleDiscountModal}
        />
        <Modal
          title="Create Custom Discount"
          subtitle={
            <div>
                Create custom discount for your students
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Name"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Validity Period"
                    margin="normal"
                    inputType="date"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Description"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Discount Value"
                    margin="normal"
                    inputType="text"
                    inputName="due_date"
                    // inputMin={formattedToday}
                    required
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.quelabel}>Reason <span className="input-required"> *</span></label>
                  <div className={classes.textandimg}>
                    <textarea
                      type="text"
                      placeholder="Input reason"
                      name="description"
                      onChange={handleChange}
                    />
                  </div>
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                variant="primary"
                buttonName="Apply"
                buttonSize="full"
                color="btndefault"
                // onClick={handleCreateNotice}
                // isLoading={isLoading}
              />
            </>
          }
          isopen={customDiscount}
          closeModal={handleCustomDiscount}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default PaymentHistory;
